import React,{ useState, useRef} from 'react';
import { resizeFile } from '../../../assets/js/imageReSizer';
import { createPost } from '../../../firebase';


function CreatePost({user}) {
    const [imgSrc, setImgSrc] = useState([]);
    const fileRef = useRef("");
    const [msg, setMsg] = useState("");

    const uploadImage = () => {
        document.getElementById("my_file").click();
    }

    const resetAllData = () => {
        setMsg("");
        setImgSrc([]);
        fileRef.current.value = "";
    }

    const saveImage = async (e) => {
        try {
            let files = e.target.files;
            if (files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    resizeFile(files[i]).then(res => setImgSrc(pre => ([...pre, res])));
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    const deletePic = (d) => {
        setImgSrc(pre => (pre.filter(p => p !== d)));
    }

    const createNewPost = () => {
        let newPost = {
            imgSrc: imgSrc.length>0 ? imgSrc : [],
            userName: user.name,
            id:user.id,
            created: new Date().toLocaleString(),
            post: msg,
            comment: [],
            lastUpdated: new Date().getTime()
        }
        createPost(newPost);
        resetAllData();
    }

    return (
        <div>
            <div className="btn-get-started" data-bs-toggle="modal" data-bs-target="#createPost">
                <i className='bi bi-pencil-square'></i> Create new Post
            </div>
            <div className="modal fade" id="createPost" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="staticBackdropLabel"> <i className='bi bi-pencil-square'></i> Create new post</h5>
                            <i className='bi bi-x bx-sm' data-bs-dismiss="modal" aria-label="Close"></i>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">

                                <div className="row gy-2">
                                    {imgSrc.length > 0 && imgSrc.map((im, index) => <div key={index} className="col-6">
                                        <img src={im} alt="pic" className="img-fluid" />
                                        <i className="bx bx-x-circle bx-flip-horizontal" style={{ color: '#d01f1f', position: 'absolute', cursor: 'pointer' }}
                                            onClick={() => deletePic(im)} />
                                    </div>)}
                                    <div className="col-12">
                                        <input type="file" id="my_file" style={{ display: "none" }} accept="image/*" ref={fileRef} multiple={true} onChange={saveImage} />
                                        <button className="btn upload" onClick={() => uploadImage()}><i className='bx bxs-camera'> Add image</i></button>
                                    </div>
                                    <div className="col-12">
                                        <textarea className="form-control" rows="5"
                                            placeholder="New Post"
                                            value={msg} onChange={(e) => setMsg(e.target.value)} />

                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-sm btn-secondary" data-bs-dismiss="modal"
                            >Cancel</button>
                            <button type="button" className="btn btn-sm btn-primary" data-bs-dismiss="modal"
                            disabled={!msg && imgSrc.length===0}
                            onClick={()=>createNewPost()}>Create</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default React.memo(CreatePost);